module.exports = __webpack_public_path__ + "static/offre_image-ab05fd2a2a8f6fd5970fb5aa50c0d877.jpg";